import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { UserRole } from '@avanzu/types';

interface ProtectedPermissionsRouteProps {
  children?: React.ReactNode;
  requireOrganisation?: boolean;
  roles?: UserRole[];
}

export const ProtectedPermissionsRoute: React.FC<ProtectedPermissionsRouteProps> = ({
  children,
  requireOrganisation = true,
  roles = [UserRole.AVANZU, UserRole.ADMIN, UserRole.MEMBER, UserRole.OWNER, UserRole.VIEWER],
}) => {
  const { loading, currentOrganisation, organisations } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!roles.includes(currentOrganisation?.role || UserRole.VIEWER)) {
    return <Navigate to="/403" replace />;
  }

  if (requireOrganisation && organisations.length === 0) {
    return <Navigate to="/select-organisation" replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default ProtectedPermissionsRoute;
